import { Controller } from "@hotwired/stimulus"

// Charge le container Matomo Tag Manager (MTM).
// La config tracking (trackPageView, événements, déclencheurs Turbo) se fait
// côté admin Matomo Cloud → Tag Manager.
//
// Conformité CNIL : assurée côté config Matomo Cloud (IP anonymisée, pas
// de cookies tiers, opt-out via iframe sur les mentions légales). Le signal
// Do Not Track n'est pas honoré ici — non requis par le guide CNIL.
//
// Idempotent : un seul chargement même si reconnecté (Turbo).
export default class extends Controller {
  static values = {
    containerId: String,
    containerUrl: String
  }

  connect() {
    this.initializeMatomoTagManager()
  }

  initializeMatomoTagManager() {
    window._mtm = window._mtm || []
    window._paq = window._paq || []
    window._paq.push(['disableCookies'])

    const containerId = this.containerIdValue
    if (!containerId) {
      console.warn("Matomo: missing container id, skipping initialization")
      return
    }

    window._mtm.push({
      'mtm.startTime': (new Date().getTime()),
      'event': 'mtm.Start'
    })

    this.loadMatomoTagManagerScript(containerId)
  }

  loadMatomoTagManagerScript(containerId) {
    if (document.querySelector(`script[src*="container_${containerId}.js"]`)) {
      return
    }

    const baseUrl = this.normalizeUrl(this.containerUrlValue) || 'https://cdn.matomo.cloud/uemadagascar.matomo.cloud/'
    const script = document.createElement('script')
    script.async = true
    script.src = `${baseUrl}container_${containerId}.js`

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  }

  normalizeUrl(value) {
    if (!value) return null
    return value.endsWith("/") ? value : `${value}/`
  }
}
